import React from "react";
import { useHistory } from "react-router-dom";
import {  FaSwimmingPool } from "react-icons/fa";

import Colors from "../../constant/Colors";
import { t } from "i18next";
import { CgPill } from "react-icons/cg";

function OrdersScreen() {
  const history = useHistory();

  const onPress = (route) => {
    history.push(`${window.location.pathname}/${route}`);
  };

  return (
    <div className="flex flex-wrap items-center w-full mt-12 justify-evenly ">
      <Card
        label={t("nutrition")}
        Icon={
          <CgPill
            className="mt-6"
            color={Colors.mainAqwaBlue}
            size={50}
          />
        }
        onPress={onPress.bind(this, "nutrition-sales")}
      />

      <Card
        label={t("swimmingItems")}
        Icon={
          <FaSwimmingPool className="mt-6" color={Colors.mainAqwaBlue} size={50} />
        }
        onPress={onPress.bind(this, "swimming-items")}
      />
    </div>
  );
}

const Card = ({ label, Icon, onPress }) => {
  return (
    <div
      onClick={onPress}
      className="flex flex-col items-center justify-center mx-4 border cursor-pointer h-60 w-60"
    >
      <h1 className="text-2xl text-center opacity-75">{label}</h1>
      {Icon}
    </div>
  );
};

export default OrdersScreen;
